import { useQuery } from '@tanstack/react-query';
import { getDestinationIdentity, type Topology } from '@/services/observability-api';
import type { SelectedTopologyItem } from './components/types';

export function useDestinationIdentity(
  topology: Topology | undefined,
  selected: SelectedTopologyItem
) {
  const node =
    selected?.type === 'node' ? topology?.nodes.find((n) => n.id === selected.id) : undefined;
  const caller =
    node?.kind === 'external' && node.id.startsWith('unresolved:')
      ? node.id.slice('unresolved:'.length)
      : undefined;
  return useQuery({
    queryKey: ['destination-identity', topology?.environment, caller, topology?.range],
    queryFn: ({ signal }) => getDestinationIdentity(caller!, topology!.range, signal),
    enabled: Boolean(caller && topology),
    staleTime: 60_000,
    gcTime: 60_000,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
